<template>
  <div>
    <div class="mt-4 mb-4">
      <div class="row">
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-md-12 text-right">
              <button
                type="button"
                class="btn btn-custom-primary"
                @click="nouveauContact"
              >
                <i class="fas fa-plus"></i>
                Nouveau contact
              </button>

              <button
                type="button"
                class="btn btn-danger ml-4"
                @click.prevent="deleteAllSelectionContact"
                v-show="isSelectContact"
              >
                <i class="fas fa-trash"></i>
                Supprimer
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <ContactDataTable
                ref="datatableContact"
                @onSelect="onSelectContactRows"
                @onRowsDelete="deleteContactRows"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from '@/http/crm/tiers_contact/tiers';
import ContactDataTable from './DataTable.vue';

import From from 'vform';

export default {
  data() {
    return {
      formContact: new From({
        nom: '',
      }),

      currentTiers: '',

      modeContact: 'create',
      titleModalContact: 'Ajout de nouveau contact',
      isSelectContact: false,
    };
  },
  components: {
    ContactDataTable,
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  methods: {
    onSelectContactRows(isSelectContact) {
      this.isSelectContact = isSelectContact;
    },
    deleteAllSelectionContact() {
      this.deleteContactRows(this.$refs.datatableContact.idsRowsSelected);
    },
    deleteContactRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.CONTACT, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatableContact.loadItems();
                this.isSelectContact = false;
              })
              .catch();
          }
        });
      }
    },
    isEditRoute() {
      return /.*edit.*/i.test(this.$route.name);
    },

    nouveauContact() {
      let prov = this.isEditRoute() ? 'e' : 's';
      this.$router.push({
        name: 'crm_contact-create',
        params: { prov: prov + this.currentTiers.id },
      });
    },

    init() {
      let id = this.$route.params.id;
      window.axios
        .get(URL.TIERS + '/' + id)
        .then((resp) => {
          this.currentTiers = resp.data.tiers;
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
